import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from "react-spinners";

class BoosterRedirect extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentDidMount() {}

    render() {
        return (
            <div className={Styles.container}>
                <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
            </div>
        );
    }
}

export default BoosterRedirect;


// WEBPACK FOOTER //
// ./src/pages/booster-redirect/signup-payment-redirect.js